import React from 'react';

export const HubContext = React.createContext({});
